"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVaApplianceType = isVaApplianceType;
exports.isMatroxApplianceType = isMatroxApplianceType;
exports.isGenericVideoApplianceType = isGenericVideoApplianceType;
const types_1 = require("./api/v1/types");
function isVaApplianceType(applianceType) {
    return [
        types_1.ApplianceType.nimbraVA220,
        types_1.ApplianceType.nimbraVA225,
        types_1.ApplianceType.nimbra410,
        types_1.ApplianceType.nimbra412,
        types_1.ApplianceType.nimbra414,
        types_1.ApplianceType.nimbra414b,
        types_1.ApplianceType.nimbraVAdocker,
    ].includes(applianceType);
}
function isMatroxApplianceType(applianceType) {
    return [
        types_1.ApplianceType.matroxMonarchEdgeE4_8Bit,
        types_1.ApplianceType.matroxMonarchEdgeE4_10Bit,
        types_1.ApplianceType.matroxMonarchEdgeD4,
        types_1.ApplianceType.matroxMonarchEdgeS1,
    ].includes(applianceType);
}
function isGenericVideoApplianceType(applianceType) {
    return applianceType === types_1.ApplianceType.riversilica || applianceType === types_1.ApplianceType.nimbra204;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwbGlhbmNlVHlwZVV0aWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYXBwbGlhbmNlVHlwZVV0aWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFZQSw4Q0FVQztBQUVELHNEQWFDO0FBRUQsa0VBRUM7QUF4Q0QsMENBQThDO0FBVzlDLFNBQWdCLGlCQUFpQixDQUFDLGFBQTRCO0lBQzFELE9BQU87UUFDSCxxQkFBYSxDQUFDLFdBQVc7UUFDekIscUJBQWEsQ0FBQyxXQUFXO1FBQ3pCLHFCQUFhLENBQUMsU0FBUztRQUN2QixxQkFBYSxDQUFDLFNBQVM7UUFDdkIscUJBQWEsQ0FBQyxTQUFTO1FBQ3ZCLHFCQUFhLENBQUMsVUFBVTtRQUN4QixxQkFBYSxDQUFDLGNBQWM7S0FDL0IsQ0FBQyxRQUFRLENBQUMsYUFBYSxDQUFDLENBQUE7QUFDN0IsQ0FBQztBQUVELFNBQWdCLHFCQUFxQixDQUNqQyxhQUE0QjtJQU01QixPQUFPO1FBQ0gscUJBQWEsQ0FBQyx3QkFBd0I7UUFDdEMscUJBQWEsQ0FBQyx5QkFBeUI7UUFDdkMscUJBQWEsQ0FBQyxtQkFBbUI7UUFDakMscUJBQWEsQ0FBQyxtQkFBbUI7S0FDcEMsQ0FBQyxRQUFRLENBQUMsYUFBYSxDQUFDLENBQUE7QUFDN0IsQ0FBQztBQUVELFNBQWdCLDJCQUEyQixDQUFDLGFBQTRCO0lBQ3BFLE9BQU8sYUFBYSxLQUFLLHFCQUFhLENBQUMsV0FBVyxJQUFJLGFBQWEsS0FBSyxxQkFBYSxDQUFDLFNBQVMsQ0FBQTtBQUNuRyxDQUFDIn0=